import Vue from 'vue';


import ColorBar from '@/components/ColorBar.vue'
Vue.component('ColorBar', ColorBar);
import IconTitle from '@/components/IconTitle.vue'
Vue.component('IconTitle', IconTitle);
import DiseaseTag from '@/components/DiseaseTag.vue'
Vue.component('DiseaseTag', DiseaseTag);
import MyTable from '@/components/MyTable.vue'
Vue.component('MyTable', MyTable);
